define(function (require, exports, module) {
    var Ticker = {
        init: function (options) {
            //默认参数
            var defaults = {
                timer: 1000,
                step: 1
            };
            var settings = $.extend(defaults, options || {});

            var _this = this;

            this.selector = "secondcount";
            this.RED_TICKER_PASSED = 0;
            this.RED_TICKER_ITEMS = [];
            this.RED_TICKER_ITEMS_ON_ACTIVE = [];


            _this.adapt();
            _this.render();

            _this.RED_TICKER_INTERVAL = window.setInterval(function () {
                _this.tick(settings.step);
            }, settings.timer);
        },
        tick: function (step) {
            var _this = this;
            _this.RED_TICKER_PASSED = _this.RED_TICKER_PASSED + step;
            for (var i = 0; i < _this.RED_TICKER_ITEMS_ON_ACTIVE.length; i++) {
                var item = _this.RED_TICKER_ITEMS_ON_ACTIVE[i];
                _this._render(item);
            }
        },
        adapt: function () {
            var _this = this;
            var a = $("[" + _this.selector + "]");
            a.each(function (n, i) {

                if ($.inArray(i, _this.RED_TICKER_ITEMS)) {
                    i.renderFn = _this.renderFn;
                    i.rendAble = 0;
                    i.secondcount = window.parseInt($(i).attr("secondcount"));
                    _this.RED_TICKER_ITEMS.push(i);
                    _this._render(i);
                }
            });
        },
        _render: function (item) {
            var _this = this;
            var secondcountRemain = item.secondcount - _this.RED_TICKER_PASSED;

            item.renderFn(_this.parseData(secondcountRemain));
        },
        render: function () {
            var _this = this;
            _this.RED_TICKER_ITEMS_ON_ACTIVE = [];

            for (var i = 0; i < _this.RED_TICKER_ITEMS.length; i++) {
                var item = _this.RED_TICKER_ITEMS[i];
                // if (_this.inScreen(item)) {
                _this.RED_TICKER_ITEMS_ON_ACTIVE.push(item);
                // }

            }
        },
        inScreen: function (dom) {
            var p = $(dom).offset();
            var result = 0;
            var cHeight = $(window).height();
            //var aHeight=$(document).height();
            var scrollTop = $(window).scrollTop();
            if (p.top > scrollTop && p.top <= scrollTop + cHeight) {
                result = 1;
            }
            return result;
        },
        parseData: function (secondcount) {
            var daySecond = 60 * 60 * 24;
            var hourSecond = 60 * 60;
            var result = {};
            result.secondcount = secondcount;
            result.day = parseInt(secondcount / (daySecond));
            result.hour = parseInt((secondcount % (daySecond)) / (hourSecond));
            result.minute = parseInt((secondcount % (hourSecond)) / (60));
            result.second = parseInt((secondcount % 60) / (1));
            return result;
        },
        renderFn: function (d) {
            var _this = this;
            var num = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

            var renderDefault = function (data) {
                if (data.secondcount < 0) {
                    return;
                }
                if ($(_this).hasClass("special")) {
                    if (data.day == 0) {
                        _this.innerHTML = "<b>" + format(data.hour) + "</b>" + '时' +
                            "<b>" + format(data.minute) + "</b>" + '分' +
                            "<b>" + format(data.second) + "</b>" + '秒';
                    } else {
                        _this.innerHTML = "<b>" + format(data.day) + "</b>" + '天' +
                            "<b>" + format(data.hour) + "</b>" + '时' +
                            "<b>" + format(data.minute) + "</b>" + '分' +
                            "<b>" + format(data.second) + "</b>" + '秒';
                    }

                } else {
                    _this.innerHTML = '<div class="bg hour">' + format(data.hour) + '</div>' +
                        '<div class="semicolon">:</div>' +
                        '<div class="bg minute">' + format(data.minute) + '</div>' +
                        '<div class="semicolon">:</div>' +
                        '<div class="bg second">' + format(data.second) + '</div>';
                }
            };

            var renderCustom = function (data) {
                _this.innerHTML = "" + format(data.day) + " d" + format(data.hour) + "h" + format(data.minute) + "m" + format(data.second) + "s";
            };

            var renderCustom_myGw = function (data) {
                if (data.hour < 0) {
                    data.hour = 0;
                }
                if (data.minute < 0) {
                    data.minute = 0;
                }
                if (data.hour < 0 && data.minute < 0) {
                    _this.innerHTML = "";
                } else {
                    _this.innerHTML = "仅剩" + format(data.hour) + "小时" + format(data.minute) + "分";
                }
            };

            var renderCustom_myGw_delay = function (data) {
                if(data.day < 0) {
                    data.day = 0;
                }
                if (data.hour < 0) {
                    data.hour = 0;
                }
                if (data.minute < 0) {
                    data.minute = 0;
                }
                _this.innerHTML = "剩余&nbsp;" + format(data.day) + "天" + format(data.hour) + "小时";
            };

            var myGwDetail_delay = function (data) {
                if(data.day < 0) {
                    data.day = 0;
                }
                if (data.hour < 0) {
                    data.hour = 0;
                }
                if (data.minute < 0) {
                    data.minute = 0;
                }
                if (data.day < 0 && data.hour < 0 && data.minute < 0) {
                    _this.innerHTML = "";
                } else {
                    _this.innerHTML = "剩余&nbsp;" + format(data.day) + "天" + format(data.hour) + "时" + format(data.minute) + "分";
                }
            };

            var myGwDetail_delay_1 = function (data) {
                if(data.day < 0) {
                    data.day = 0;
                }
                if (data.hour < 0) {
                    data.hour = 0;
                }
                if (data.minute < 0) {
                    data.minute = 0;
                }
                if (data.day < 0 && data.hour < 0 && data.minute < 0) {
                    _this.innerHTML = "";
                } else {
                    _this.innerHTML = format(data.day) + "天" + format(data.hour) + "时" + format(data.minute) + "分";
                }
            };

            var renderCustom_myGwDetail = function (data) {
                if (data.hour < 0) {
                    data.hour = 0;
                }
                if (data.minute < 0) {
                    data.minute = 0;
                }
                if (data.hour < 0 && data.minute < 0) {
                    _this.innerHTML = "";
                } else {
                    _this.innerHTML = format(data.hour) + "小时" + format(data.minute) + "分";
                }
            };

            var renderCustom_temai = function (data) {
                if (data.hour < 0) {
                    data.hour = 0;
                }
                if (data.minute < 0) {
                    data.minute = 0;
                }
                if (data.second < 0) {
                    data.second = 0;
                }
                _this.innerHTML = format(data.hour) + "小时" + format(data.minute) + "分" + format(data.second) + "秒后结束";
            };

            var format = function (number) {
                var _this = this;
                if (!$.inArray(number, num)) {
                    return "0" + number;
                } else {
                    return number;
                }
            };

            switch ($(_this).attr("render_type")) {
                case "Custom":
                    renderCustom(d);
                    break;
                case "myGw":
                    renderCustom_myGw(d);
                    break;
                case "myGwDetail":
                    renderCustom_myGwDetail(d);
                    break;
                case "temai":
                    renderCustom_temai(d);
                    break;
                case "myGw_delay":
                    renderCustom_myGw_delay(d);
                    break;
                case "myGw_detailDelay":
                    myGwDetail_delay(d);
                    break;
                case "myGw_detailDelay_1":
                    myGwDetail_delay_1(d);
                    break;
                default:
                    renderDefault(d);
                    break;
            }
        }
    };
    module.exports = Ticker;
});



// WEBPACK FOOTER //
// ./src/js/unit/ticker/ticker.js